import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useReorderSingleSeriesMutation = createMutationHook(
  MembershipsCreatorV2ApiClient.reorderSingleSeries,
  {
    mutationKey: ['reorderSingleSeries'],
  },
)
